import { Link, Typography } from "@material-ui/core";
import { useAppContext } from "../contexts/AppContext";

export default function Copyright() {
    const appContext = useAppContext();
    if (!appContext?.checkVersion())
        window.location.reload();

    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://meenachilriver.org">
                MeenachilRiver.org
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
            <span style={{ float: 'right' }}>
                v{appContext?.CURRENT_VERSION}
            </span>
        </Typography>
    );
}